<template>
  <div class="page_admin_accommodation">
    <h1>Ubytování</h1>
    <tabloid name="accommodationOrders" :columns="columns" :data="accommodationOrders">
      <template v-slot:outpostId="{ value }">{{ value }}. PH</template>
      <template v-slot:id="{ value }">{{ value | cz_accommodation }}</template>
      <template v-slot:actions="{ row }">
        <button class="remove" @click="remove(row.outpostId, row)">
          <i class="fa fa-times"></i>
        </button>
      </template>
    </tabloid>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import tabloid from "../../components/tabloid.vue";

export default {
  name: "admin_accommodation",
  components: {
    tabloid,
  },
  data: () => ({
    columns: {
      outpostId: { title: "Hlídka" },
      id: { title: "Označení ubytování" },
      amount: { title: "Počet míst" },
      price: { title: "Cena" },
      actions: { title: " " },
    }
  }),
  computed: {
    ...mapState(['accommodationOrders']),
  },
  methods: {
    remove(outpostId, acc) {
      if (!confirm(`Opravdu chcete ${outpostId}. PH odebrat ubytování '${this.$options.filters.cz_accommodation(acc.id)}'?`)) return;

      this.$store.commit("remove", {
        paths: ["accommodationOrders", acc.id]
      });
    }
  }
};
</script>

<style lang="sass">
@import ../../sass/_components

.page_admin_accommodation
  .remove
    @include button-danger()
</style>